<!-- 注册/登录 -->
<template>
  <div v-show="pageShow" class="registrationLogin loginCom" ref="registrationLogin">
    <close v-if="!this.$root.miniprogram" :fromPath="fromPath" />
    <div class="codeLogin loginMmain">
      <div class="codeLoginTop">
        <div class="codeLoginTitle">注册/登录</div>
        <div class="codeLoginDescribe fontWeightCom">新用户注册将自动创建账号</div>
      </div>
      <div class="codeLoginMain">
        <input
          type="tel"
          placeholder="请输入手机号"
          maxlength="11"
          class="codeLoginPhone fontWeightCom mobile"
          @input="getPhoneIpt"
          v-model="userPhone"
          ref="registrIpt"
          @keyup.delete="onDelete()"
        />
      </div>
      <div class="codeLoginLine loginLine"></div>
    </div>
    <sendButton
      :buttonText="validationBtn"
      @sendCodeBtn="validationCode"
      :yuntuColor="yuntuColor"
      loginWay="registrationLogin"
      :isActiveClass="isActiveClass"
    />
    <confirm
      v-if="confirmFlag"
      :yuntuColor="yuntuColor"
      @close="close"
      @receivePraive="receivePraive"
      @validationCode="validationCode"
      @checked="checked"
    />
    <div
      class="passLoginBtn fontWeightCom"
      :class="{ yuntuColor: yuntuColor }"
      @click="passLoginBtn"
    >
      密码登录
    </div>
    <div class="Bottom registrBottom">
      <termsAgreement :yuntuColor="yuntuColor" @receivePraive="receivePraive" ref="agre" />
    </div>

    
   
  </div>
</template>

<script>
import '@/assets/css/loginCommon.css';
import { Toast } from 'vant';
import close from '@/components/login/close.vue';
import sendButton from '@/components/login/sendButton.vue';
import termsAgreement from '@/components/login/termsAgreement.vue';
import confirm from '@/components/login/confirm.vue';
import { queryCode, reqPhonesliderCode } from '@/api/login';
import { Facet } from '@antv/g2plot';
import { initCaptcha,triggerCaptcha } from '@/utils/tools';

export default {
  namespaced: true,
  components: {
    close,
    sendButton,
    termsAgreement,
    confirm,
  },
  data() {
    return {
      userPhone: '',
      isActiveClass: false,
      urlParams: null,
      pagesParams: null,
      fromPath: '',
      validationBtn: '发送验证码',
      loading: false,
      pravieStatus: false,
      obj: {},
      showPage: false,
      confirmFlag: false,
      pageShow: false,
      isUseJVerification: true,
      yuntuColor: false,
    };
  },
  computed: {},
  watch: {
    userPhone() {
      this.changePhone();
    },
  },
  methods: {
    receivePraive(status) {
      this.pravieStatus = status;
    },
    changePhone() {
      const { userPhone } = this;
      if (String(userPhone).length === 11) {
        this.isActiveClass = true;
        return;
      }
      this.isActiveClass = false;
    },
    onDelete() {
      const { userPhone } = this.$store.state;
      if (userPhone?.length === 0) return;
      this.$store.dispatch('saveUserPhone', '');
    },
    getPhoneIpt() {
      const { userPhone } = this;
      if (userPhone.length >= 11) {
        this.userPhone = userPhone.slice(0, 11);
        this.$store.dispatch('saveUserPhone', userPhone);
      }
    },
    passLoginBtn() {
      // console.log('去密码登录', this.urlParams, this.pagesParams);
      this.$router.replace({
        path: '/passwordLogin',
        query: JSON.parse(this.urlParams),
        pagesParams: JSON.parse(this.pagesParams),
      });
    },
    close() {
      this.confirmFlag = false;
    },
    checked() {
      this.$refs.agre.checked = true;
    },
    async validationCode() {
      //++++++++++++++++
      if (this.loading) {
        return;
      }
      const { userPhone } = this;
      const isPhone = /^1[3-9]\d{9}$/g.test(userPhone);
      if (String(userPhone).length === 11 && isPhone && this.isActiveClass) {
        this.obj = Object.assign(this.pagesParams ? JSON.parse(this.pagesParams) : {}, {
          loginWay: 'login',
          loginSource: this.yuntuColor ? 'yuntulogin' : '',
        });
        // if (!this.pravieStatus) {
        //   Toast('请阅读并勾选隐私协议');
        //   return;
        // }
        if (!this.pravieStatus) {
          this.confirmFlag = true;
          return;
        }
        // 检查是否存在未过期的验证码
        const savedTimer = sessionStorage.getItem('codeTimer');
        if (savedTimer) {
          const timerData = JSON.parse(savedTimer);
          if (timerData.phone === userPhone) {
            const remainTime = Math.ceil((timerData.endTime - Date.now()) / 1000);
            if (remainTime > 0) {
              // 同一手机号且倒计时未结束，直接跳转
              this.$router.replace({
                name: 'getCode',
                query: JSON.parse(this.urlParams),
                params: this.obj,
              });
              return;
            }
          }
        }
        // 不同手机号或倒计时已结束，走原有流程
        this.loading = true;
        const _this = this;
        triggerCaptcha();
      } else {
        Toast('请输入正确格式的手机号');
      }
    },
    // 发送验证码
    async getNewVerification(nvcVal) {
      this.validationBtn = '正在发送验证码';
      const data = {
        company: this.yuntuColor ? 1 : 0,
        type: this.loginWay ? this.loginWay : 'login',
        phone: String(this.userPhone) || '',
        nvcVal,
        sceneId: '16dqi6jq'
      };
      const res = await reqPhonesliderCode(data);
      initCaptcha('16dqi6jq',this.nvcCallback);
      this.loading = false;
      if (res.code === 0) {
        this.validationBtn = '发送验证码';
        if (res.data.status === 0) {
          sessionStorage.setItem(
            'codeTimer',
            JSON.stringify({
              phone: this.userPhone,
              endTime: Date.now() + 59000,
              startTime: Date.now(),
            }),
          );
          this.$router.replace({
            name: 'getCode',
            query: JSON.parse(this.urlParams),
            params: this.obj,
          });
        } else if (res.data.status === 1) {
          // 业务服务器请求回调控制是否需要二次验证
          if (res.data.bizCode === 800 || res.data.bizCode === 900) {
            // 无痕验证失败，直接拦截
            Toast('验证失败，请重新尝试');
          } else if (res.data.bizCode === 400) {
              triggerCaptcha()
          }
        }
      } else {
        Toast(res.msg);
      }
    },
   

    Toast(msg) {
      Toast({
        message: msg,
        duration: 3 * 1000,
        position: 'top',
      });
    },
    initQuickLogin(vm) {
      if (!this.$root.showQuickLogin || this.$root.miniprogram) {
        vm.pageShow = true;
        return;
      }
      const that = this;
      setTimeout(() => {
        vm.isUseJVerification = false;
        vm.pageShow = true;
      }, 3000);
      // eslint-disable-next-line no-unused-expressions
      window.JVerificationInterface?.init({
        appkey: 'c76ec3b512d9a2551cd3c977', // 极光官网中创建应用后分配的 appkey，必填
        debugMode: true, // 设置是否开启 debug 模式。true 则会打印更多的日志信息。设置 false 则只会输出 w、e 级别的日志。
        domainName: window.location.origin,
        success: (data) => {
          if (vm.isUseJVerification) {
            console.log(data, '初始化成功--app');
            // eslint-disable-next-line no-unused-expressions
            window.JVerificationInterface?.getToken({
              operater: 'CM',
              success: (data) => {
                console.log(data, '获取token成功--app');
                that.$router.replace({
                  path: '/quickLogin',
                  query: Object.assign(JSON.parse(this.urlParams), { operater: data?.operater }),
                  pagesParams: JSON.parse(this.pagesParams),
                });
              },
              fail: (b) => {
                vm.pageShow = true;
                console.log(b, '获取token失败');
              },
            });
          } else {
            vm.pageShow = true;
          }
        },
        fail: (err2) => {
          console.log(err2, '初始化失败--app');
          vm.pageShow = true;
        },
      });
    },
    nvcCallback(data){
      console.log(data,1111111100000)
      this.getNewVerification(data)
    }
  },
  created() {
    const { userPhone } = this.$store.state;
    this.userPhone = userPhone || '';
    // this.urlParams = this.$route.query.redirect;
    this.urlParams = window.localStorage.getItem('pagesQuery');
    this.pagesParams = window.localStorage.getItem('pagesParams')
      ? window.localStorage.getItem('pagesParams')
      : null;
    if (JSON.parse(this.urlParams)?.loginSource === 'yuntulogin') {
      this.yuntuColor = true;
    }
  },
  mounted() {
    initCaptcha('16dqi6jq',this.nvcCallback);
    // openMiniLoginCallBack();
    document.getElementsByClassName('app')[0].setAttribute('style', 'height: 100%');
  },
  beforeDestroy() {
    document.getElementsByClassName('app')[0].removeAttribute('style');
    if (this.$root.initOperater) {
      this.$root.showQuickLogin = true;
    }
  },
  beforeRouteEnter: (to, from, next) => {
    next(async (vm) => {
      // eslint-disable-next-line no-param-reassign
      vm.fromPath = from.path;
      vm.initQuickLogin(vm);
    });
  },
};
</script>
<style lang="scss" scoped>
.fontWeightCom {
  font-weight: 400;
}

.registrationLogin {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #fff;
}

.codeLogin {
  padding-top: 89px;
  font-size: 29px;
}

.codeLoginTitle {
  color: #333;
  font-weight: 500;
  font-size: 51px;
  line-height: 72px;
}

.codeLoginDescribe {
  padding: 18px 0 74px 0;
  color: #787878;
}

.codeLoginMain {
  width: 605px;
  // height: 84px;
}

.mobile {
  padding: 22px 0;
}

.codeLoginLine {
  width: 605px;
  height: 2px;
  margin-bottom: 56px;
  background-color: #eee;
}

.codeLoginPhone {
  width: 100%;
  height: 100%;
}

.passLoginBtn {
  margin: 21.74px 72.46px 0 0;
  color: #ff6c02;
  font-size: 25px;
  line-height: 36px;
  text-align: right;
}

.registrBottom {
  // padding-top: 500px;
  position: absolute;
  bottom: 100px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  .wrapperCenter {
    position: relative;
    width: 600px;
    height: 290px;
    background-color: #fff;

    h2 {
      font-weight: normal;
      font-size: 34px;
      line-height: 120px;
      text-align: center;
    }

    .couponClose {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 34px;
      height: 34px;
    }

    .MyDomSlide {
      width: 600px;
      margin: 30px auto;
    }
  }
}

.sliderCode {
  margin-top: 45px;
}

::v-deep .nc_wrapper {
  margin: 0 auto;
}

::v-deep .nc-container .nc_scale .btn_ok,
::v-deep .nc-container .nc_scale span {
  height: 68px !important;
}

._nc .stage1 .slider {
  height: 52px !important;
  background-color: #ddd !important;
  border-radius: 0 !important;
  box-shadow: 0 0 3px #999 !important;
}

._nc .stage1 .track div {
  color: #fff !important;
  border-radius: 0 !important;
}

.nc .stage1 .bg-green {
  background-color: #78c430 !important;
}

.nc .stage1 .bg-red {
  background-color: #78c430 !important;
}

.yuntuColor {
  color: $yuntuColor !important;
}
</style>
